type RegisterCodeType = {
  key: string;
  type: string;
}

/**
 * 登録コード種別
 */
export const registerCodeTypeMaster: RegisterCodeType[] = [
  {
    key: 'hokkokubank',
    type: ''
  },
  {
    key: 'okasan',
    type: 'SECURITIES_ACCOUNT_NUMBER'
  }
]
